import { render, staticRenderFns } from "./CustomerSelection.vue?vue&type=template&id=231f142b&"
import script from "./CustomerSelection.vue?vue&type=script&lang=ts&"
export * from "./CustomerSelection.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerSelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports